module.exports = __webpack_public_path__ + "static/jetsemani-d0570b691e4c2e6516271db5dea340ce.png";